export enum SortDirection {
  'Ascending' = 1,
  'Descending' = 2,
}
